import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ─────────────────────────────────────────────────────────────
// Kill Service Workers.
// Motivo: algún SW registrado por la infra del preview (Cloudflare /
// bootstrap externo) intercepta navegaciones cross-origin (target="_blank"
// hacia google.com/maps) y devuelve ERR_BLOCKED_BY_RESPONSE con el warning:
//   "The service worker navigation preload request was cancelled before
//    'preloadResponse' settled."
// La app no usa PWA/offline, así que:
//   1) Bloqueamos futuras llamadas a register() (por si un script inyectado
//      posterior intenta registrar un SW).
//   2) Desregistramos todos los SW que puedan haber quedado en el navegador
//      de usuarios que ya cargaron una versión con SW.
//   3) Vaciamos las Cache Storage para eliminar respuestas viejas.
// Falla silenciosamente si el navegador no soporta la API.
// ─────────────────────────────────────────────────────────────
try {
  if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
    // (1) neutralizar register() futuros
    try {
      const sw = navigator.serviceWorker;
      const noopReg = { unregister: () => Promise.resolve(true), scope: "" };
      sw.register = () => Promise.resolve(noopReg);
    } catch { /* algunos navegadores no permiten reescribir el prototipo */ }
    // (2) desregistrar los ya presentes
    navigator.serviceWorker.getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .catch(() => { /* noop */ });
  }
  if (typeof window !== "undefined" && "caches" in window) {
    window.caches.keys()
      .then((keys) => Promise.all(keys.map((k) => window.caches.delete(k))))
      .catch(() => { /* noop */ });
  }
} catch { /* noop */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
